export const iconFontAwesomeDisasterCrisisPlantWilt = (
	<i className="fa-solid fa-plant-wilt"></i>
);
